import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
} from "./../../components/card/card.jsx";
import DataTable from "react-data-table-component";
import {
  generateLocationToArray,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { useAuth } from "../../contexts/AuthContext";
import { dataProcess } from "../../api";
import { parserAPI } from "../../utils/parser.jsx";
import { useNavigate } from "react-router-dom";
import { dateToToday } from "../../utils/helper";
import { Spinner } from "react-bootstrap";
import { Loader } from "../../utils/helper";

import ImageViewer from "../../components/ImageViewer";
import { LocationFilter } from "../../components/LocationFilter";
import { useLocation } from "react-router-dom";

function MachineHealth() {
  let dataLocation = useLocation();
  const [query, setQuery] = useState({
    company: true,
    status: dataLocation?.state?.status || "",
  });
  const [active, setActive] = React.useState(0);
  const navigate = useNavigate();
  const [code1, setCode1] = useState();
  const [selectedStatus, setSelectedStatus] = useState(
    dataLocation?.state?.status || ""
  );
  const [datas, setData] = React.useState([]);
  const [selectedLocation, setSelectedLocation] = React.useState();
  const { config } = useAuth();
  const [loading, setLoading] = useState(true);
  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }
  const handleChangeStatus = (status) => {
    setQuery((prev) => ({
      ...prev,
      status: status ? status : "",
    }));
    setSelectedStatus(status);
  };
  const getStatus = (status) => {
    switch (status) {
      case "Acceptable":
        return "status-accept";
      case "Observe":
        return "status-observe";
      case "Alert":
        return "status-alert";
      case "Critical":
        return "status-critical";
      default:
        return "status-pending";
    }
  };

  async function fetchData() {
    setLoading(true);
    const res = await dataProcess.machineHealthAll("Location", query);
    const data = await parserAPI(res);
    data.forEach((d) => {
      const locationNameArr = [];
      generateLocationToArray(d.location, locationNameArr);
      d.location_arr = locationNameArr.reverse();
    });
    setData(data);
    setLoading(false);
  }
  useEffect(() => {
    fetchData();
  }, [query]);
  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };
  const columns = [
    ...generateLocationWording().map((w, i) => ({
      name: w,
      selector: (row) => printLocation(row.location_arr[i]),
    })),
    {
      name: "Machine Name",
      selector: (row) => row.machine_name,
    },
    {
      name: "Machine Type",
      selector: (row) => row.machine_type.name,
    },
    {
      name: "Machine Health Classification",
      selector: (row) => row.machine_type.name,
      cell: (row) => (
        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100px",
            color: "#2A2E5D",
          }}
          className={getStatus(row.MachineHealth[0]?.status)}
        >
          {row.MachineHealth[0] ? row.MachineHealth[0]?.status : "Pending"}
        </div>
      ),
    },
  ];
  const ExpandedComponent = ({ data }) => {
    const [imgLoading, setImgLoading] = useState(true);
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">
                <ImageViewer src={data?.attachments?.filePhoto}></ImageViewer>
              </div>
              <div className="col-md-9">
                <div>
                  Machine Name : <b>{data.machine_name}</b>
                </div>
                <div>
                  Machine Health Classification :{" "}
                  <b
                    style={{
                      color: "#2A2E5D",
                    }}
                    className={getStatus(data.MachineHealth[0]?.status)}
                  >
                    {data.MachineHealth[0]
                      ? data.MachineHealth[0]?.status
                      : "Pending"}
                  </b>
                </div>
                <div>
                  Last Updated :{" "}
                  <b>
                    {" "}
                    {data.MachineHealth[0]
                      ? dateToToday(data.MachineHealth[0]?.created_at)
                      : "N/A"}
                  </b>
                </div>
                {data.MachineHealth[0] ? (
                  <div>
                    <div>Description :</div>{" "}
                    <div className="alert alert-light">
                      {data.MachineHealth[0]?.description}
                    </div>
                  </div>
                ) : null}

                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/machine/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>
                <button
                  onClick={() => navigate("/sensor/live/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Live Sensor Data
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#/">MACHINE</a>
                </li>
                <li className="breadcrumb-item active">MACHINE HEALTH</li>
              </ul>

              <h4
                style={{ cursor: "pointer", fontSize: "1rem" }}
                className="page-header small"
                data-bs-toggle="modal"
                data-bs-target="#modalLg"
              >
                Machine Health Classification{" "}
                <i className="fa fa-info-circle"></i>
              </h4>

              <hr className="mb-4" />

              <div id="datatable" className="mb-5">
                <div className="row mb-2 justify-content-end">
                  <div className="col-4 col-sm-6">
                    <LocationFilter onChange={handleChangeLocationFilter} />
                  </div>
                  <div className="col-3">
                    <select
                      value={selectedStatus}
                      onChange={(e) => handleChangeStatus(e.target.value)}
                      className="form-select  btn btn-sm btn-outline-theme"
                      defaultValue=""
                    >
                      <option value="">- Show All -</option>
                      <option value="Acceptable">Acceptable</option>
                      <option value="Observe">Observe</option>
                      <option value="Alert">Alert</option>
                      <option value="Critical">Critical</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </div>
                </div>
                <div className="modal fade" id="modalLg">
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <Card>
                        <CardHeader>Machine Alert Status</CardHeader>
                        <CardBody>
                          <div
                            style={{
                              width: "100%",
                              height: "50px",
                              borderRadius: "50px",
                              background:
                                "linear-gradient(90deg, rgba(175,234,205,1) 0%, rgba(175,234,205,1) 3%, rgba(234,228,175,1) 33%, rgba(255,190,126,1) 66%, rgba(255,119,156,1) 97%, rgba(255,119,156,1) 100%)",
                            }}
                          ></div>
                          <div>
                            <div className={"row"}>
                              <div className={"col-sm-3 position-relative"}>
                                <img
                                  className={`health-marker-1 ${
                                    active === 0 ? "active-marker" : ""
                                  }`}
                                  src={
                                    active === 0
                                      ? "/img/mark_health_active.png"
                                      : "/img/mark_health.png"
                                  }
                                  onClick={() => {
                                    setActive(0);
                                  }}
                                  style={{ cursor: "pointer" }}
                                  alt=""
                                />
                                <div
                                  onClick={() => {
                                    setActive(0);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "20px",
                                    marginLeft: "9px",
                                    color: "#2A2E5D",
                                    fontSize: "13px",
                                    background:
                                      active === 0 ? "#AFEACD" : "#DBDBDB",
                                    padding: "4px 9px",
                                    width: "100px",
                                    textAlign: "center",
                                    borderRadius: "5px",
                                    border:
                                      active === 0
                                        ? "1px solid #8acaaf"
                                        : "1px solid #c5c5c5",
                                  }}
                                >
                                  Acceptable
                                </div>
                                {active === 0 && (
                                  <div
                                    style={{
                                      padding: "5px",
                                      fontSize: 13,
                                      mt: 2,
                                    }}
                                  >
                                    <ul>
                                      <li>Near zero risk of machine failure</li>
                                      <li>
                                        {" "}
                                        Machine data collected is within the ISO
                                        limits
                                      </li>
                                      <li>No maintenance required</li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                              <div className={"col-sm-3 position-relative "}>
                                <img
                                  className={`health-marker-2 ${
                                    active === 1 ? "active-marker" : ""
                                  }`}
                                  src={
                                    active === 1
                                      ? "/img/mark_health_active.png"
                                      : "/img/mark_health.png"
                                  }
                                  onClick={() => {
                                    setActive(1);
                                  }}
                                  style={{ cursor: "pointer" }}
                                  alt=""
                                />
                                <div
                                  onClick={() => {
                                    setActive(1);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "20px",
                                    marginLeft: "15px",
                                    color: "#2A2E5D",
                                    fontSize: "13px",
                                    background:
                                      active === 1 ? "#EAE4AF" : "#DBDBDB",
                                    padding: "4px 9px",
                                    width: "100px",
                                    textAlign: "center",
                                    borderRadius: "5px",
                                    border:
                                      active === 1
                                        ? "1px solid #b9b89c"
                                        : "1px solid #c5c5c5",
                                  }}
                                >
                                  Observe
                                </div>
                                {active === 1 && (
                                  <div
                                    style={{
                                      padding: "5px",
                                      fontSize: 13,
                                      mt: 2,
                                    }}
                                  >
                                    <ul>
                                      <li>
                                        Vibration levels are above ideal, but
                                        risk of failure is low and machine
                                        remains stable
                                      </li>
                                      <li>
                                        Recommended to{" "}
                                        <b>
                                          {" "}
                                          observe and monitor the condition of
                                          the machine{" "}
                                        </b>
                                      </li>
                                      <li>
                                        Maintenance teams can do{" "}
                                        <b>minor inspections</b> and start
                                        securing spare parts in the meantime
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                              <div className={"col-sm-3 position-relative "}>
                                <img
                                  className={`health-marker-3 ${
                                    active === 2 ? "active-marker" : ""
                                  }`}
                                  src={
                                    active === 2
                                      ? "/img/mark_health_active.png"
                                      : "/img/mark_health.png"
                                  }
                                  onClick={() => {
                                    setActive(2);
                                  }}
                                  style={{ cursor: "pointer" }}
                                  alt=""
                                />
                                <div
                                  onClick={() => {
                                    setActive(2);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "52px",
                                    marginTop: "20px",
                                    color: "#2A2E5D",
                                    fontSize: "13px",
                                    background:
                                      active === 2 ? "#FFBE7E" : "#DBDBDB",
                                    padding: "4px 9px",
                                    width: "100px",
                                    textAlign: "center",
                                    borderRadius: "5px",
                                    border:
                                      active === 2
                                        ? "1px solid #c89a75"
                                        : "1px solid #c5c5c5",
                                  }}
                                >
                                  Alert
                                </div>
                                {active === 2 && (
                                  <div
                                    style={{
                                      padding: "5px",
                                      fontSize: 13,
                                      mt: 2,
                                    }}
                                  >
                                    <ul>
                                      <li>
                                        Data supports the presence of advanced
                                        component wear
                                      </li>
                                      <li>
                                        {" "}
                                        Significant{" "}
                                        <b>
                                          risk of failure in the next 3 to 6
                                          months
                                        </b>{" "}
                                        depending on the machine usage, but
                                        there is also a potential that the
                                        machine <b>may unexepectedly stop</b>
                                      </li>
                                      <li>
                                        {" "}
                                        Maintenance teams should{" "}
                                        <b>schedule for maintenance</b> and
                                        mobilize spare parts
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                              <div className={"col-sm-3 position-relative "}>
                                <img
                                  className={`health-marker-4 ${
                                    active === 3 ? "active-marker" : ""
                                  }`}
                                  onClick={() => {
                                    setActive(3);
                                  }}
                                  src={
                                    active === 3
                                      ? "/img/mark_health_active.png"
                                      : "/img/mark_health.png"
                                  }
                                  style={{ cursor: "pointer" }}
                                  alt=""
                                />
                                <div
                                  onClick={() => {
                                    setActive(3);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "75px",
                                    marginTop: "20px",
                                    color: "#2A2E5D",
                                    fontSize: "13px",
                                    background:
                                      active === 3 ? "#FF779C" : "#DBDBDB",
                                    padding: "4px 9px",
                                    width: "100px",
                                    textAlign: "center",
                                    borderRadius: "5px",
                                    border:
                                      active === 3
                                        ? "1px solid #c9628d"
                                        : "1px solid #c5c5c5",
                                  }}
                                >
                                  Critical
                                </div>
                                {active === 3 && (
                                  <div
                                    style={{
                                      padding: "5px",
                                      fontSize: 13,
                                      mt: 2,
                                    }}
                                  >
                                    <ul>
                                      <li>
                                        Significant{" "}
                                        <b>
                                          risk of failure in the upcoming 2 to
                                          12 weeks
                                        </b>{" "}
                                        depending on the machine usage, but
                                        there is also a potential that the
                                        machine <b>may unexepectedly stop</b>
                                      </li>
                                      <li>
                                        Maintenance teams are recommended to
                                        perform urgent initial sight, sound and
                                        smell inspections or use other
                                        non-invasive methods while machine is
                                        still running
                                      </li>
                                      <li>
                                        <b>
                                          Maintenance and repairs should be
                                          urgently prioritized
                                        </b>{" "}
                                        at the next available opportunity
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </div>
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        highlightOnHover
                        expandableRows
                        defaultSortAsc={true}
                        defaultSortFieldId={3}
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineHealth;
